import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "src/app/Services/auth.service";
import { ApiServiceService } from "../../../../Services/api-service.service";
import { ChangePasswordComponent } from "src/app/Module/Main/change-password/change-password.component";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-admin-header",
  templateUrl: "./admin-header.component.html",
  styleUrls: ["./admin-header.component.css"],
})
export class admin_headerComponent implements OnInit {
  collapsed = true;
  isNotifyOpen: boolean = false;
  displayName: any;
  isDropdownOpen = false;
  constructor(
    private authService: AuthService,
    private router: Router,
    private authenticationService: AuthService,
    private elementRef: ElementRef,
    private apiService: ApiServiceService,
    private bsModalRef: BsModalRef,
    private bsModalService: BsModalService,
  ) {}

  @HostListener("document:click", ["$event.target"])
  public onClick(targetElement: HTMLElement): void {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.isNotifyOpen = false;
    }
  }

  ngOnInit(): void {
    this.displayName = this.authService.getDisplayName();
    this.getNotification();
  }

  changePassword() {
    let bsModalRef = this.bsModalService.show(ChangePasswordComponent, {
      class: "modal-md modal-dialog-centered",
      ignoreBackdropClick: true,
    });
    bsModalRef?.content?.onConfirmClicked.subscribe((v) => {
      bsModalRef.hide();
    });
  }

  logout() {
    this.authenticationService.logout();
  }

  hasAccess(permissions: string[]) {
    return this.authenticationService.hasAnyPermission(permissions);
  }

  home() {
    this.router.navigate(["/"]);
  }

  navigateToAnnualReturn(annualReturnType: string): void {
    this.router.navigate(["/admin/annual-returns"], {
      queryParams: { q: annualReturnType },
    });
  }

  navTo(path) {
    this.router.navigate([path]);
  }

  toggleNotification() {
    this.isNotifyOpen = !this.isNotifyOpen;
  }

  notification: any[] = [];
  total: any;

  getNotification() {
    const url = `/assessments/get/notification`;
    this.apiService.get(url).subscribe((res) => {
      this.total = res.total;
      this.notification = res.results;
    });
  }

  notify(inactive: string, id: number) {
    const url = `/assessments/delete/notification?id=${id}&action=${inactive}`;
    this.apiService.post_(url, {}).subscribe((res) => {
      this.getNotification();
    });
  }
}
